import { render, staticRenderFns } from "./SecurityQuestion.vue?vue&type=template&id=1667d052&"
import script from "./SecurityQuestion.vue?vue&type=script&lang=ts&"
export * from "./SecurityQuestion.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports